import { AfterViewInit, Component } from '@angular/core';
import * as Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
import HighchartsSunburst from 'highcharts/modules/sunburst';
import { EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomServiceService } from '../../service/custom-service.service';
import { fciWebsiteService } from '../../service/fci-website.service';
import { HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment';
declare let $: any;
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';
import { TranslateService } from '@ngx-translate/core';
HighchartsMore(Highcharts);
HighchartsSolidGauge(Highcharts);
HighchartsSunburst(Highcharts);

@Component({
  selector: 'app-rice',
  templateUrl: './rice.component.html',
  styleUrls: ['./rice.component.css']
})
export class RiceComponent implements AfterViewInit {
  selectedYear: any ='';
  selectedState: any ='';
  january: any ='';
  february: any ='';
  march: any ='';
  april: any ='';
  may: any ='';
  june: any ='';
  july: any ='';
  august: any ='';
  september: any ='';
  october: any ='';
  november: any ='';
  december: any ='';
  totalCount: any ='';
  september_prev_year:any ='';
  ShowRiceTabView : boolean =false;

  riceToggle(boolean: boolean){
    this.ShowRiceTabView = boolean;
    $('.Toggle').removeClass('active');
    if(boolean){
      $('#ricechart').addClass('active');
    } else {
      $('#ricetbl').addClass('active');
    }
  }


  public ngAfterViewInit(): void {
    this.createChartColumn();
  }
  
  startYear:any;
constructor(private fciwebservice: fciWebsiteService, private routerparam: ActivatedRoute,private router: ActivatedRoute,private encDec: EncryptDecryptService,private route: Router,private httpservice: CustomServiceService,public translate: TranslateService) {
  
    //code
};
start:number=0;
limit:number=10;
currentPage:number = 1;
totalRecords:number=0;
ProcriceData: any=[];
monthRiceData:any ;
language:any = sessionStorage.getItem('locale');
endYear:any;
  ngOnInit(): void {
    this.selectedYear = this.getCurrentFinancialYear();
    this.getRiceProcListing('',this.selectedYear,'',this.start,this.limit,this.currentPage);
    this.generateFinancialYears();
   
    // this.startYear = this.selectedYear.split('-')[0];

    const firstPart = this.selectedYear.split('-')[0];

    // Extract the last two digits
    this.startYear = (parseInt(firstPart) % 100).toString().padStart(2, '0');
    const secPart = this.selectedYear.split('-')[1];
    this.endYear = (parseInt(secPart) % 100).toString().padStart(2, '0');
    // this.endYear = this.selectedYear.split('-')[1];
    this.getProcStateUTList();
    
  }

  apirespons:any;
  // ProcwheatData:any;
  totalJan:any;
getRiceProcListing(selectedState:any,selectedYear:any,category:any,start:number,limit:number,currentPage:number){
  let param= {
    'category':'rice',
    'selectedState':selectedState,
    'selectedYear':selectedYear,
    
  }
  this.fciwebservice.getRiceProcListing(param).subscribe((response:any) => {
    switch (response.type) { 
      case HttpEventType.Sent:
        //console.log('Sent' + HttpEventType.Sent);
        break;
      case HttpEventType.ResponseHeader:
        //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
        break;
      case HttpEventType.UploadProgress:
        //this.evenTotal = response.total;
        //this.progress = Math.round(response.loaded / this.evenTotal * 100);
        break;
      case HttpEventType.Response:
        this.apirespons = response.body;
        let respData = this.apirespons.RESPONSE_DATA;
        let respToken = this.apirespons.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
        if (respToken == verifyToken) {
          let res = JSON.parse(Buffer.from(respData, 'base64').toString());
           this.ProcriceData = res.result;
           this.monthRiceData = res.res;
           this.january = res.resultTotal.totaljan;
           this.february = res.resultTotal.totalfeb;
           this.march = res.resultTotal.totalmar;
           this.april = res.resultTotal.totalapr;
           this.may = res.resultTotal.totalmay;
           this.june = res.resultTotal.totaljun;
           this.july = res.resultTotal.totaljuly;
           this.august = res.resultTotal.totalaug;
           this.september = res.resultTotal.totalsep;
           this.october = res.resultTotal.totaloct;
           this.november = res.resultTotal.totalnov;
           this.december = res.resultTotal.totaldec;
           this.totalCount = res.resultTotal.total;
           this.september_prev_year= res.resultTotal.totalSepPrev;
           this.createChartColumn();
           if(res.result.length > 0){
            this.totalRecords = res.result.length;
          } else {
            this.totalRecords = 0;
          }
        } 
    }
  });
}
onStateSelected(): void {
  this.getRiceProcListing(this.selectedState,this.selectedYear,'',this.start,this.limit,this.currentPage);
}

onYearSelected(): void {
  const firstPart = this.selectedYear.split('-')[0];

    // Extract the last two digits
    this.startYear = (parseInt(firstPart) % 100).toString().padStart(2, '0');
    const secPart = this.selectedYear.split('-')[1];
    this.endYear = (parseInt(secPart) % 100).toString().padStart(2, '0');
  this.getRiceProcListing(this.selectedState,this.selectedYear,'',this.start,this.limit,this.currentPage);
}
pageChanged(page: any) {

  let param_arr = []; 
  let category,fyear;
  category="";
  fyear="";

  this.currentPage=page;
  this.start=(this.currentPage - 1)*this.limit;
  this.getRiceProcListing(this.selectedState,this.selectedYear,'category',this.start,this.limit,this.currentPage);
}
getCurrentFinancialYear(): string {
  const currentDate = new Date();
  const financialYearStart = new Date(currentDate.getFullYear(), 3, 1); // Assuming a financial year starting on April 1

  if (currentDate < financialYearStart) {
    return `${currentDate.getFullYear() - 1}-${currentDate.getFullYear()}`;
  } else {
    return `${currentDate.getFullYear()}-${currentDate.getFullYear() + 1}`;
  }
}
financialYears: any = [];
generateFinancialYears() {
  
  const startYear = 2012;
  const endYear = new Date().getFullYear();
  console.log(endYear);
  for (let year = startYear; year <= endYear; year++) {
    const start = year;
    const end = year + 1;
    const financialYear = `${start}-${end}`;
    this.financialYears.push(financialYear);
  }

  this.financialYears.sort((k: any, v: any) => v.localeCompare(k)); 
}
  
// private getRandomNumber(min: number, max: number, total: number): number {
//   return Math.floor(total)
// }


private getRandomNumber(min: number, max: number, total: any): any {
  return  parseFloat(total).toFixed(2);
}
private getRandomDecimal(min: number, max: number, total: any): any {
  const randomValue = Math.random() * (max - min) + min;
  const validDecimalPlaces = Math.max(0, Math.min(total, 100));
  return parseFloat((total));
}
private getRandomMonth(min: number, max: number, month: any): any {
  const randomValue = Math.random() * (max - min) + min;
  const validDecimalPlaces = Math.max(0, Math.min(month, 100));
  return parseFloat((month));
}
content_apiresponse:any;
StateUTList:any;
public   getProcStateUTList(){
  let param ={

  }
  this.fciwebservice.getProcStateUTList(param).subscribe((response:any) => {

     switch (response.type) { 
      case HttpEventType.Sent:
        //console.log('Sent' + HttpEventType.Sent);
        break;
      case HttpEventType.ResponseHeader:
        //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
        break;
      case HttpEventType.UploadProgress:
        //this.evenTotal = response.total;
        //this.progress = Math.round(response.loaded / this.evenTotal * 100);
        break;
      case HttpEventType.Response:
        this.apirespons = response.body;
        let respData = this.apirespons.RESPONSE_DATA;
        let respToken = this.apirespons.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
        if (respToken == verifyToken) {
          let res = JSON.parse(Buffer.from(respData, 'base64').toString());
           this.StateUTList = res.result;  
        } 
    }
  });

}
public mapProcDataToCategories(stockData: any[]): number[] {

  const categories: string[] = [];
  this.StateUTList.forEach((item: { state_English: string; }) => {
    categories.push(item.state_English);
  });
  
  const amounts: number[] = [];

  for (const category of categories) {
    const stateData = stockData.find(item => item.state_English === category);
    if (stateData) {
      amounts.push(stateData.total);
    } else {
      amounts.push(0);
    }
  }
  return amounts;
}

public mapProcMonthData(stockData: any[]): any[] {
  const months = ['september_prev_year', 'october', 'november', 'december', 'january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september'];
  const amounts: number[] = new Array(months.length).fill(0);


  if (Array.isArray(stockData)) {
    stockData.forEach((item) => {
      for (let i = 0; i < months.length; i++) {
        amounts[i] += parseFloat(item[months[i]]);
      }
    });
  } else {
  }
  return amounts;
}


riceAmount:any;
riceAmounts:any;
private createChartColumn(): void {

  if(this.selectedState == ''){
  this.riceAmount = this.mapProcDataToCategories(this.ProcriceData);
  let date = new Date();
  const data: any[] = [];
  const categories: string[] = [];
  this.StateUTList.forEach((item: { state_English: string; }) => {
  categories.push(item.state_English);
   });
  for (let i = 0; i < categories.length; i++) {
    date.setDate(new Date().getDate() + i);
    data.push({
      name: `${date.getDate()}/${date.getMonth() + 1}`,
      y: this.getRandomDecimal(1, 10, this.riceAmount[i]),
    });
  }

  const chart = Highcharts.chart('chart-rice' as any, {
   
    title: {
      text: this.language === 'English' ? 'Rice Procurement' : 'चावल की खरीद'
    },
    chart: {
      type: 'column',
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    
    yAxis: {
      min: 0,
      title: undefined,
    },
    xAxis: {
      categories: this.StateUTList.map((item: { state_English: any;state_Hindi :any;}) => this.language === 'English' ? item.state_English : item.state_Hindi),
    },
    
    tooltip: {
      headerFormat: ``,
      pointFormat: `<div>{series.name}: {point.y}</div>`,
      shared: true,
      useHTML: true,
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
      },
      },
    series: [{
      name: 'Amount',
      data,
color: '#006637'
    }],
  } as any);

  }
else{
  this.riceAmounts = this.mapProcMonthData(this.monthRiceData);
  let date = new Date();
  const data: any[] = [];
  const categoriesMonth= ['Septmeber','October','November','December','January','Febuary','March','April','May','June','July','August','Septmeber'];
    for (let i = 0; i < categoriesMonth.length; i++) {
    date.setDate(new Date().getDate() + i);
    data.push({
      name: ``,
      y: this.getRandomMonth(1, 10, this.riceAmounts[i]),
    });
  }
  const chart = Highcharts.chart('chart-rice' as any, {
    title: {
      text: this.language === 'English' ? 'Rice Procurement' : 'चावल की खरीद'
    },
    chart: {
      type: 'column',
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    
    yAxis: {
      min: 0,
      title: undefined,
    },
    xAxis: {
      categories: this.language === 'English' ? ['Septmeber','October','November','December','January','Febuary','March','April','May','June','July','August','Septmeber'] :["सितंबर", "अक्टूबर", "नवंबर", "दिसंबर","जनवरी", "फरवरी", "मार्च", "अप्रैल", "मई", "जून","जुलाई", "अगस्त","सितंबर", ],
    },
    tooltip: {
      headerFormat: ``,
      pointFormat: `<div>{series.name}: {point.y}</div>`,
      shared: true,
      useHTML: true,
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
      },
      // bar: {
      //   dataLabels: {
      //     enabled: true,
      //   },
      // },
    },
    series: [{
      name: 'Amount',
      data,
color: '#006637'
    }],
  } as any);
}

}





countDecimals:any = (value:any):any =>{ 
  if ((value % 1) != 0) 
      return value.toString().split(".")[1].length;  
  return 0;
};
NumberFormart(num:any):any{
if(num=='' || num==null){
  return 0;
}
if(parseFloat(num) <= 0){
  if(this.countDecimals(num) > 5){
    return parseFloat(num).toFixed(5);
  }
  return num;
}
if(parseFloat(num)){
  if(this.countDecimals(num) > 5){
    return parseFloat(num).toFixed(5);
  }
  return num;
}
return num;
}








}
